import { inject } from 'mobx-react';
import { SideMenuItemComponent } from './component';
export const SideMenuItem = inject(({ router }) => ({
    currentPath: router.currentPath,
    navigate: router.navigate,
}))(SideMenuItemComponent);
//# sourceMappingURL=index.js.map